import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid2, Tooltip, useTheme } from "@mui/material"
import { FormLabelContext } from "@ngt/opms"
import { FC, useContext } from "react"

interface ILabelWithTooltipProps {
    content: string
}

export const LabelWithTooltip: FC<ILabelWithTooltipProps> = ({
    content
}) => {
    const { label } = useContext(FormLabelContext);
    const theme = useTheme();
    return (
        <Grid2
            container
            spacing={2}
            alignItems={"center"}
        >
            {label}
            <Tooltip
                title={content}
            >
                <FontAwesomeIcon 
                    icon={faCircleInfo} 
                    color={theme.palette.primary.light}
                    cursor={"pointer"}
                />
            </Tooltip>
        </Grid2>
    )
}

export default LabelWithTooltip